import qs from 'qs';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const InstitutionsListEndpoint = {
  dataURL: 'education/institutions',
  sourceName: 'institutionsList',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters = {}, sort, search }) => {
    const { name, ...filtersRest } = filters;
    const urlData = {
      filters: { ...filtersRest, search: name || search },
      sort
    };

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;
    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }), {
      arrayFormat: 'brackets'
    });

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta, data } = payload;
    const { limit, count, offset } = meta || {};
    const payloadData = data || payload;

    return {
      data: concat ? (state.data || []).concat(payloadData) : payloadData,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count: count ?? state.count
    };
  }
};

export default InstitutionsListEndpoint;
